import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  PageHeader,
  Button,
  Divider,
  Table,
  Form,
  Select,
  Input,
  Descriptions,
  message,
  Image,
} from "antd";
import { FlexRowReverseContainer } from "../Common/Container.styles";
import { Option } from "antd/lib/mentions";

import * as userAPI from "../../api/user";
import { dateToString } from "../../util/common";

function CertificateTypeDetail({ isEdit = true }) {
  const navigate = useNavigate();
  const params = useParams();

  const [loading, setLoading] = useState(true);
  //const [user, setUser] = useState(null);
  const [setting, setAdmin] = useState(null);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [form] = Form.useForm();
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));



  // const fetchAdmin = () => {
  //   userAPI
  //     .getCertificateType2({ id: params.id })
  //     .then((res) => {
  //        if (res.data.linusCode === 1) {
  //       setAdmin(res.data.data);
  //       if (setting?.products?.length) {
  //         setSelectedProducts(setting.products);
  //       }
  //         setLoading(false);
  //        }
  //     })
  //     .catch((error) => {
  //       if (error.response.data.detail) {
  //         message.error(error.response.data.detail);
  //       } else if (error.response.status < 500) {
  //         for (let key of Object.keys(error.response.data)) {
  //           message.error(`${key}: ${error.response.data[key]}`);
  //         }
  //       } else {
  //         message.error("오류가 발생했습니다.");
  //       }
  //     });
  // };

  const fetchAdmin = async () => {
    try {
      const res = await userAPI.getCertificateType2({ id: params.id });
  
      if (res.data.linusCode === 1) {
        const fetchedData = res.data.data;
        setAdmin(fetchedData);
  
        // 바로 setting 대신 fetchedData.products 사용
        if (fetchedData?.products?.length) {
          setSelectedProducts(fetchedData.products);
        }
  
        await delay(1000); // 1초 대기
        setLoading(false);
      }

    } catch (error) {
      if (error.response?.data?.detail) {
        message.error(error.response.data.detail);
      } else if (error.response?.status < 500) {
        for (let key of Object.keys(error.response.data)) {
          message.error(`${key}: ${error.response.data[key]}`);
        }
      } else {
        message.error("오류가 발생했습니다.");
      }
    }
  };
  


  // useEffect(() => {
  //   fetchAdmin();
  // }, []);

  useEffect(() => {
    if (isEdit) {
      fetchAdmin();
    } else {
      setLoading(false);
    }
  }, []);


  const productOptions = [
    { label: "[개인] PTS 심리유형탐색 도구", value: 1 },
    { label: "[단체] PTS 심리유형탐색 도구", value: 2 },
    { label: "[개인] PTS 도형심리탐색 도구", value: 3 },
    { label: "[단체] PTS 도형심리탐색 도구", value: 4 },
  ];

  // const discountOptions = [
  //   { label: "0%", value: 0 },
  //   { label: "10%", value: 10 },
  //   { label: "20%",value: 20 },
  //   { label: "30%", value: 30 },
  //   { label: "40%", value: 40 },
  //   { label: "50%",value: 50 },
  //   { label: "60%", value: 60 },
  //   { label: "70%", value: 70 },
  //   { label: "80%",value: 80 },
  //   { label: "90%", value: 90 },
  //   { label: "100%", value: 100 },
  // ];

  const discountOptions = Array.from({ length: 101 }, (_, i) => ({
    label: `${i}%`,
    value: i,
  }));


  const handleSelectChange = (value) => {
    const option = productOptions.find((o) => o.value === value);
    if (!option) return;

    const alreadyExists = selectedProducts.some((p) => p.product_id === value);
    if (!alreadyExists) {
      setSelectedProducts([
        ...selectedProducts,
        {
          product_id: value,
          product_name: option.label.replace(/\[.*?\]\s*/, ""), // 이름만 추출
          product_group: option.label.match(/\[(.*?)\]/)?.[1] || "", // 그룹만 추출
        },
      ]);
    }else{
      alert("이미 연결된 검사가 존재합니다.")
    }
  };

  const handleRemoveProduct = (productId) => {
    setSelectedProducts((prev) =>
      prev.filter((p) => p.product_id !== productId)
    );
  };

  const handleSave = async () => {
    // if (!setting?.id) {
    //   message.error("ID가 없습니다. 새로고침 후 다시 시도해주세요.");
    //   return;
    // }
    
    const params = {
      id: setting?.id,
      name: form.getFieldValue("name"),
      discount_rate: form.getFieldValue("discount"),
      use_yn: form.getFieldValue("use_yn"),
      del_yn: form.getFieldValue("del_yn"),
      products: selectedProducts.map((p) => p.product_id),
    };


    try {
    
  
      if (params.id) {
        // 수정

        const res = await userAPI.editCertificateType2(params);
        if (res.data.linusCode === 1) {
          message.success("수정 완료");
          navigate("/user/certificate-type2");
        }
      } else {
        // 생성
        const res = await userAPI.createCertificateType2(params);
        if (res.data.linusCode === 1) {
          message.success("생성 완료");
          navigate("/user/certificate-type2");
        }
      }
    } catch (error) {
      message.error("저장 중 오류 발생");
      console.error(error);
    }
  };
  
  const handleDelete = async () => {
   
    const params = {
      id: setting?.id,
    };

    try {
      
      if (params.id) {
       //삭제
        const res = await userAPI.deleteCertificateType2(params);
        if (res.data.linusCode === 1) {
          message.success("삭제 완료");
          navigate("/user/certificate-type2");
        }
      }
    } catch (error) {
      message.error("삭제 중 오류 발생");
      console.error(error);
    }
  };





  return (
    <div>
      <PageHeader className="site-page-header" title="구매 자격 종류 상세" />
      <FlexRowReverseContainer>
        <Button
          onClick={(e) => {
            e.preventDefault();
            navigate(`/user/certificate-type2`);
          }}
          style={{ margin: "0 10px" }}
        >
          목록
        </Button>
      </FlexRowReverseContainer>
      <Divider />
      {/* 글번호, 공지제목, 작성자명, 등록년월일시, 최정수정년월일시, 글내용*/}
      {loading && <></>}
      {!loading && (
        <>
         
            <Form form={form} layout="vertical">
            <Form.Item name="id"   label={<span style={{ fontWeight: 'bold' }}>번호</span>} span={3} initialValue={setting?.id ?? "-"}>
              <Input disabled />
            </Form.Item>
            <Form.Item name="name"   label={<span style={{ fontWeight: 'bold' }}>자격명</span>} span={3} initialValue={setting?.name ?? "-"}>
              <Input placeholder="자격명을 입력해주세요." />
            </Form.Item>
              <Form.Item name="product_name" label={<span style={{ fontWeight: 'bold' }}>검사 도구</span>}  span={3}>
                <Select
                  placeholder="검사 도구를 선택하세요."
                  onChange={handleSelectChange}
                >
                  {productOptions.map((c) => (
                    <Select.Option key={c.value} value={c.value}>
                      {c.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name="products" label={<span style={{ fontWeight: 'bold' }}>연결된 검사</span>} span={3}>
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    {selectedProducts.length > 0 ? (
                      selectedProducts.map(
                        ({ product_id, product_group, product_name }) => (
                          <Button
                            key={product_id}
                            size="small"
                            type="default"
                            style={{
                              borderRadius: 20,
                              display: "inline-flex",
                              alignItems: "center",
                            }}
                            onClick={() => handleRemoveProduct(product_id)}
                          >
                            [{product_group}] {product_name}
                            <span
                              onClick={(e) => {
                                e.stopPropagation();
                                handleRemoveProduct(product_id);
                              }}
                              style={{
                                marginLeft: 6,
                                fontWeight: "bold",
                                cursor: "pointer",
                                userSelect: "none",
                              }}
                            >
                              ✖
                            </span>
                          </Button>
                        )
                      )
                    ) : (
                      "-"
                    )}
                  </div>
              </Form.Item>

            <Form.Item name="discount" label={<span style={{ fontWeight: 'bold' }}>할인율</span>}  span={3} initialValue={setting?.discount_rate}>
              <Select placeholder="할인율을 선택하세요.">

                {discountOptions.map(({ label, value }) => (
                  <Select.Option key={value} value={value}>
                    {label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name="use_yn" label={<span style={{ fontWeight: 'bold' }}>사용여부</span>} span={3} initialValue={setting?.use_yn}>
              <Select>
                <Select.Option value="Y">예</Select.Option>
                <Select.Option value="N">아니오</Select.Option>
              </Select>
            </Form.Item>

            {/* <Form.Item name="del_yn" label={<span style={{ fontWeight: 'bold' }}>삭제여부</span>}  span={3} initialValue={setting?.del_yn}>
              <Select>
                <Select.Option value="Y">예</Select.Option>
                <Select.Option value="N">아니오</Select.Option>
              </Select>
            </Form.Item> */}
            <Form.Item
              name="del_yn"
              label={<span style={{ fontWeight: 'bold' }}>삭제여부</span>}
              initialValue={isEdit ? setting?.del_yn : "N"}   // isEdit === false → N 고정
            >
              <Select disabled={!isEdit}>   {/* isEdit === false → 비활성화 */}
                <Select.Option value="Y">예</Select.Option>
                <Select.Option value="N">아니오</Select.Option>
              </Select>
            </Form.Item>

            <Form.Item name="writer" label={<span style={{ fontWeight: 'bold' }}>작성자</span>}  span={3} initialValue={"관리자"}>
              <Input disabled />
            </Form.Item>

            <Form.Item name="createdDate" label={<span style={{ fontWeight: 'bold' }}>등록일</span>}  span={3} initialValue={dateToString(setting?.createdDate)}>
              <Input disabled />
            </Form.Item>
          </Form>


        </>
        
      )}
        <FlexRowReverseContainer>
        <Button
          onClick={async (e) => {
            e.preventDefault();
            await handleSave(); // 저장 API 호출
            //navigate(`/user/certificate-type2`);
          }}
          style={{ margin: "0 10px" }}
        >
          저장
        </Button>
        <Button
          onClick={async (e) => {
            e.preventDefault();
            await handleDelete(); // 삭제 API 호출
            //navigate(`/user/certificate-type2`);
          }}
          style={{ margin: "0 10px" }}
        >
          삭제
        </Button>
      </FlexRowReverseContainer>
      
    </div>
  );
}

export default CertificateTypeDetail;
